import { render, staticRenderFns } from "./OngoingLiveSession.vue?vue&type=template&id=1eeda358&"
import script from "./OngoingLiveSession.vue?vue&type=script&lang=js&"
export * from "./OngoingLiveSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports